import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_api/og')({
  component: OGRoute,
})

function OGRoute() {
  return (
    <img
      src="/default-og-image.png"
      alt="Open Graph"
      style={{ display: 'block', width: '100%', maxWidth: 1200, margin: '0 auto' }}
    />
  )
}
